import { SupplierCardType } from '@/components/v3/atoms/card/card'
import { GTM_EVENT } from '@/constants'
import type { SupplierCarouselType } from '@/utils/articles/supplier-carousel/resolve-supplier-carousel'
import { sendGTMEvent } from '@next/third-parties/google'

// Same listing fields as `categoryImpressionGTMEvent`, so GA4 can combine
// both impression types per listing.
export const carouselImpressionGTMEvent = (
  listingId: number | string,
  supplierProfilePath: string,
  listingType: SupplierCardType,
  carouselType: SupplierCarouselType
) => {
  sendGTMEvent({
    event: GTM_EVENT.CAROUSEL_IMPRESSION,
    listing_id: String(listingId),
    supplier_profile_path: supplierProfilePath,
    listing_type: listingType,
    carousel_type: carouselType,
  })
}
